import type { BasicResponseDto, CreateServiceEntrySheetDto, GetServiceEntrySheetOrderLinesPagedRequestDto, ServiceEntrySheetDetailsDto, ServiceEntrySheetGridDto, ServiceEntrySheetPagedRequestDto, ServiceEntrySheetResumeDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { IntegrationStatusDto } from '../integrations-status/models';
import type { OrderLineDto } from '../order-lines/models';
import type { PagedResultDto } from '../pagination/models';
import type { ServiceEntrySheetLogDto } from '../service-entry-sheet-logs/models';

@Injectable({
  providedIn: 'root',
})
export class ServiceEntrySheetService {
  apiName = 'Default';
  

  generateServiceEntrySheetByInput = (input: CreateServiceEntrySheetDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, BasicResponseDto>({
      method: 'POST',
      url: '/api/app/service-entry-sheet/generate-service-entry-sheet',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  generateServiceEntrySheetByPeriodProviderAndPurchaseOrderLineByPeriodIdAndProviderIdAndPurchaseOrderLine = (periodId: number, providerId: number, purchaseOrderLine: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, BasicResponseDto>({
      method: 'POST',
      url: '/api/app/service-entry-sheet/generate-service-entry-sheet-by-period-provider-and-purchase-order-line',
      params: { periodId, providerId, purchaseOrderLine },
    },
    { apiName: this.apiName,...config });
  

  getAllByInput = (input: ServiceEntrySheetPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ServiceEntrySheetGridDto>>({
      method: 'GET',
      url: '/api/app/service-entry-sheet',
      params: { serviceEntrySheetId: input.serviceEntrySheetId, providerId: input.providerId, vendorId: input.vendorId, periodId: input.periodId, purchaseOrderNumber: input.purchaseOrderNumber, purchaseOrderLine: input.purchaseOrderLine, serviceEntrySheetNumber: input.serviceEntrySheetNumber, dateFrom: input.dateFrom, dateTo: input.dateTo, state: input.state, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getDetailsByServiceEntrySheetId = (serviceEntrySheetId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ServiceEntrySheetDetailsDto>({
      method: 'GET',
      url: `/api/app/service-entry-sheet/details/${serviceEntrySheetId}`,
    },
    { apiName: this.apiName,...config });
  

  getIntegrationsByServiceEntrySheetId = (serviceEntrySheetId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IntegrationStatusDto[]>({
      method: 'GET',
      url: `/api/app/service-entry-sheet/integrations/${serviceEntrySheetId}`,
    },
    { apiName: this.apiName,...config });
  

  getOrderLinesByInput = (input: GetServiceEntrySheetOrderLinesPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OrderLineDto>>({
      method: 'GET',
      url: '/api/app/service-entry-sheet/order-lines',
      params: { serviceEntrySheetId: input.serviceEntrySheetId, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getServiceEntrySheetLogsByServiceEntrySheetId = (serviceEntrySheetId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ServiceEntrySheetLogDto[]>({
      method: 'GET',
      url: `/api/app/service-entry-sheet/service-entry-sheet-logs/${serviceEntrySheetId}`,
    },
    { apiName: this.apiName,...config });
  

  getServiceEntrySheetResumeByPeriodProviderAndPurchaseOrderLineByPeriodIdAndProviderIdAndPurchaseOrderLine = (periodId: number, providerId: number, purchaseOrderLine: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ServiceEntrySheetResumeDto>({
      method: 'GET',
      url: '/api/app/service-entry-sheet/service-entry-sheet-resume-by-period-provider-and-purchase-order-line',
      params: { periodId, providerId, purchaseOrderLine },
    },
    { apiName: this.apiName,...config });
  

  revertByServiceEntrySheetId = (serviceEntrySheetId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, BasicResponseDto>({
      method: 'POST',
      url: `/api/app/service-entry-sheet/revert/${serviceEntrySheetId}`,
    },
    { apiName: this.apiName,...config });
  

  validateServiceEntrySheetWithCurrentProviderByServiceEntrySheetId = (serviceEntrySheetId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/service-entry-sheet/validate-service-entry-sheet-with-current-provider/${serviceEntrySheetId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
